import {Box, styled, TextField} from "@mui/material";
import {color} from "../../../../theme/includes/color";

interface GradientBorderWrapperProps {
  focused?: boolean
  hovered?: boolean
  borderRadius?: string
}

export const GradientBorderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'focused' && prop !== 'hovered',
})<GradientBorderWrapperProps>(({ focused, hovered, borderRadius = '16px' }) => ({
  width: focused ? '100%' : '100%',
  padding: '2px',
  borderRadius: borderRadius,
  display: 'inline-block',
  background: focused
    ? 'linear-gradient(94deg, #1131F5 43.57%, #63BAD0 87.34%)'
    : hovered
      ? color('grey-400')
      : 'transparent',
  transition: 'background 0.3s ease',
}))

export const GradientInput = styled(TextField)<{boxShadow?: string}>(({ boxShadow = '#F4F5F6' }) =>({
  backgroundColor: color('white-100'),
  border: 'none',
  borderRadius: '14px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  input: {
    padding: '14.5px 16px',
    fontWeight: '400',
    color: color('black-100'),
  },
  '& input:-webkit-autofill': {
    '-webkit-box-shadow': `0 0 0 100px ${boxShadow} inset !important`,
    '-webkit-text-fill-color': color('black-100'),
  },
  '& input:active': {
    outline: 'none',
  },
}))
